import ActionTypes from '../actions/actionTypes';

const initialState = {
  primaryActionButton: null,
  secondaryActionButton: null,
  tertiaryActionButton: null,
};

export function modalMetaReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.MODAL.RESET_BUTTONS:
      return {
        ...state,
        primaryActionButton: null,
        secondaryActionButton: null,
        tertiaryActionButton: null,
      };
    case ActionTypes.MODAL.SET_PRIMARY_BUTTON:
      return {
        ...state,
        primaryActionButton: payload,
      };
    case ActionTypes.MODAL.SET_SECONDARY_BUTTON:
      return {
        ...state,
        secondaryActionButton: payload,
      };
    case ActionTypes.MODAL.SET_ALL_BUTTONS:
      return {
        ...state,
        primaryActionButton: payload.primaryActionButton,
        secondaryActionButton: payload.secondaryActionButton,
        tertiaryActionButton: payload.tertiaryActionButton,
      };
    default:
      return state;
  }
}
